import { Component, inject } from '@angular/core';

import { AppPreferences } from '../../services/app-preferences';
import { LoadingService } from '../loading.service';

@Component({
  selector: 'app-global-loader',
  imports: [],
  templateUrl: './global-loader.html',
  styleUrl: './global-loader.scss',
})
export class GlobalLoader {
  readonly loading = inject(LoadingService);
  readonly preferences = inject(AppPreferences);
}
